import { Injectable, signal } from "@angular/core";
import { SidePanelOpenOptions, SidePanelState } from "../models/side-panel/side-panel-open-options.model";

@Injectable({ providedIn: "root" })
export class SidePanelService {
  private readonly openState = signal(false);
  private readonly panelState = signal<SidePanelState | null>(null);

  readonly isOpen = this.openState.asReadonly();
  readonly config = this.panelState.asReadonly();

  open<T>(options: SidePanelOpenOptions<T>): void {
    this.panelState.set({
      component: options.component,
      title: options.title,
      icon: options.icon,
      iconClass: options.iconClass,
      data: options.data
    });
    this.openState.set(true);
  }

  close(): void {
    this.openState.set(false);
  }

  clear(): void {
    this.panelState.set(null);
  }
}
